export enum TextureType {
  ROCK = 'rock',
  WOOD = 'wood',
  MARBLE = 'marble',
  COAL = 'coal',
}
